"use client";

import { useEffect } from "react";
import { usePathname, useRouter } from "next/navigation";

export default function useCorrectRoute(canonical) {
  const pathname = usePathname();
  const router = useRouter();
  useEffect(() => {
    if (!canonical || !pathname) return;

    try {
      // Current URL parts
      const currentParts = pathname.replace(/^\/|\/$/g, "").split("/");

      // Canonical URL parts
      const canonicalPath = new URL(canonical, window.location.origin).pathname;

      const canonicalParts = canonicalPath.replace(/^\/|\/$/g, "").split("/");

      // Ignore last slug
      const currentParentParts = currentParts.slice(0, -1);
      const canonicalParentParts = canonicalParts.slice(0, -1);

      const isParentRouteMismatch =
        currentParentParts.length !== canonicalParentParts.length ||
        currentParentParts.some(
          (part, index) => part !== canonicalParentParts[index],
        );

      // Redirect if parent route is wrong
      if (isParentRouteMismatch) {
        const correctPath = `/${canonicalParts.join("/")}`;

        // Avoid unnecessary replace
        if (pathname !== correctPath) {
          router.replace(correctPath);
        }
      }
    } catch (err) {
      console.error("Correct route check failed", err);
    }
  }, [pathname, router, canonical]);
}
